module.exports = __webpack_public_path__ + "img/history.4e3b4181.png";